// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---pages-404-jsx": () => import("./../../../pages/404.jsx" /* webpackChunkName: "component---pages-404-jsx" */),
  "component---pages-index-jsx": () => import("./../../../pages/index.jsx" /* webpackChunkName: "component---pages-index-jsx" */),
  "component---src-templates-chart-gallery-page-jsx": () => import("./../../../src/templates/chart-gallery-page.jsx" /* webpackChunkName: "component---src-templates-chart-gallery-page-jsx" */),
  "component---src-templates-doc-page-jsx": () => import("./../../../src/templates/doc-page.jsx" /* webpackChunkName: "component---src-templates-doc-page-jsx" */),
  "component---src-templates-home-jsx": () => import("./../../../src/templates/home.jsx" /* webpackChunkName: "component---src-templates-home-jsx" */)
}

